module.exports = __webpack_public_path__ + "static/media/double-enveloppe-rad.63ddcb70.png";